import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { toast } from "react-hot-toast";

import Logo from "../../assets/logo.png";

import api from "../../services/api";
import useStore from "../../store";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const { user, setUser } = useStore();

  const handleSubmit = async (evt) => {
    evt.preventDefault();
    try {
      const res = await api.post("login", { username, password });
      if (!res.data.ok) throw res;
      api.setToken(res.data.token);
      setUser(res.data.user);
      toast.success(`Hey ${res.data.user.name}, Welcome to JayVisa portal`, {
        duration: 4000,
      });
    } catch (e) {
      console.log(e);
      toast.error(e?.message || "An error occurred. Please try again.");
    }
  };

  if (user) return <Navigate to="/" replace />;

  return (
    <div className="flex items-center justify-center h-screen bg-gray-100 relative">
      {/* Login Card */}
      <div className="bg-white shadow-md rounded-lg p-8 max-w-lg w-full z-10">
        {/* Logo */}
        <div className="text-center mb-10">
          <img
            src={Logo}
            alt="Logo"
            className="mx-auto mb-4 object-contain max-h-28 invert"
          />
          <h1 className="text-2xl font-bold text-gray-800 mt-10">
            Login to Your Account
          </h1>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label
              htmlFor="username"
              className="block text-sm font-medium text-gray-700"
            >
              Username
            </label>
            <input
              id="username"
              required
              value={username}
              onChange={(evt) => setUsername(evt.target.value)}
              className="mt-1 block w-full px-4 py-2 border rounded-lg shadow-sm focus:ring-gray-500 focus:border-gray-500 lowercase placeholder:capitalize"
              placeholder="Enter your username"
            />
          </div>

          <div className="mb-6">
            <label
              htmlFor="password"
              className="block text-sm font-medium text-gray-700"
            >
              Password
            </label>
            <input
              required
              type="password"
              id="password"
              value={password}
              onChange={(evt) => setPassword(evt.target.value)}
              className="mt-1 block w-full px-4 py-2 border rounded-lg shadow-sm focus:ring-gray-500 focus:border-gray-500"
              placeholder="Enter your password"
            />
          </div>

          <button
            type="submit"
            className="w-full bg-black text-white font-medium py-2 px-4 rounded-lg shadow hover:bg-gray-800 transition"
          >
            Login
          </button>
        </form>

        {/* <p className="text-sm text-center text-gray-600 mt-4">
          Don’t have an account?{" "}
          <a href="/signup" className="text-blue-600 hover:underline">
            Sign up
          </a>
        </p> */}
      </div>
    </div>
  );
};

export default Login;
